// sentry-config.js — las opciones con las que se inicializa Sentry.
//
// Viven acá y no adentro de `index.js` por una razón concreta: los cuatro
// ganchos de depuración (`beforeSend`, `beforeSendTransaction`,
// `beforeBreadcrumb`, `beforeSendSpan`) son lo único que separa a un
// subencargado en EE.UU. del nombre y el RUT de un paciente, y un refactor
// del arranque de la app puede soltar uno sin que nada falle. Extraídos, el
// cableado se prueba (sentry-config.test.js) y soltar un gancho pone la suite
// en rojo. Hallazgo del revisor externo sobre el fix de P0-5 (auditoría Ley
// 21.719, Planner #347 / #1235).
import * as Sentry from "@sentry/react";

import {
  depurarBreadcrumb,
  depurarEvento,
  depurarSpan,
} from "./sentry-scrub";

export const opcionesDeSentry = ({ dsn, environment, release }) => ({
  dsn,
  environment,
  release,
  // Replay desactivado: su grabador bufferiza mutaciones del DOM en continuo
  // (incluso con sessionSampleRate=0, si onError>0 graba siempre para poder
  // enviar el "video" ante un error) y eso causa jank/menos FPS en la UI
  // pesada del turno. Se mantienen tracing + captura de errores.
  integrations: [
    Sentry.browserTracingIntegration(),
    // Sin breadcrumbs de consola: un `console.log(row)` en el Turno sería
    // una fila de paciente adentro del evento.
    Sentry.breadcrumbsIntegration({ console: false }),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  sendDefaultPii: false,
  // Errores y transacciones de tracing pasan por el mismo filtro: los dos
  // llevan request.url (la página, con su query), extra, contexts, tags y
  // breadcrumbs; las transacciones además los spans con la URL de cada
  // request.
  beforeSend: depurarEvento,
  beforeSendTransaction: depurarEvento,
  beforeBreadcrumb: depurarBreadcrumb,
  // El span standalone de INP (la interacción más lenta de la página) se
  // manda en su propio envelope y NO pasa por beforeSend: su nombre es el
  // árbol del DOM del elemento clickeado, con el aria-label que en el
  // cockpit mobile lleva el nombre del paciente. Este es el único gancho que
  // lo ve. Devolver null acá no lo descarta: hay que depurarlo.
  beforeSendSpan: depurarSpan,
});
